import { AssetCreateAttributesInput } from '@atom/types/inventory';
import { SchemaTree } from '@atom/types/schema';

import ChatAssetDraftAttributeRow from './ChatAssetDraftAttributeRow';

import classes from '../chat.module.css';

type WorkflowAttribute = {
  value: string | number | boolean | null;
  confidence: 'high' | 'medium' | 'low';
  reason: string;
};

type ChatAssetDraftAttributesProps = {
  schema: SchemaTree;
  workflowAttributes: Record<string, WorkflowAttribute>;
  attributes: AssetCreateAttributesInput;
  onAttributeChange: (id: string, value: any) => void;
  errorAttributeIds: Set<string>;
  disabled?: boolean;
};

const ChatAssetDraftAttributes = ({
  schema,
  workflowAttributes,
  attributes,
  onAttributeChange,
  errorAttributeIds,
  disabled,
}: ChatAssetDraftAttributesProps) => {
  const groups = schema.attributeGroups ?? [];

  return (
    <div className={classes.assetDraftCardAttributes}>
      {groups.map(group => (
        <div key={group.id}>
          {groups.length > 1 && (
            <div className={classes.assetDraftCardAttributeGroupName}>
              {group.name}
            </div>
          )}
          {group.attributes.map(attribute => {
            const workflowAttr = workflowAttributes[attribute.id];
            const value = attributes[attribute.id]?.value ?? null;

            return (
              <ChatAssetDraftAttributeRow
                key={attribute.id}
                attribute={attribute}
                value={value}
                confidence={workflowAttr?.confidence ?? 'high'}
                reason={workflowAttr?.reason ?? ''}
                onChange={onAttributeChange}
                error={errorAttributeIds.has(attribute.id)}
                disabled={disabled}
              />
            );
          })}
        </div>
      ))}
    </div>
  );
};

export default ChatAssetDraftAttributes;
